var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 609 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Tertiary",
    d: "M0.284,0.43L609.284,0.43L609.284,144.998L0.284,108.83L0.284,0.43Z",
    fill: "#F39200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Secondary",
    d: "M0.284,0L609.284,0L609.284,76.568L0.284,129.32L0.284,0Z",
    fill: "#FFBA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Primary",
    d: "M-0.716,0L609.284,0L609.284,24L-2,132.338L-0.716,0Z",
    fill: "#183F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsBottom);
export default __webpack_public_path__ + "static/media/details_bottom.170ffa9108b2b20c881bd768162f85b0.svg";
export { ForwardRef as ReactComponent };